import components from "@/js/components";
import pages from "@/js/pages";
import forms from "@/js/forms";
import menuHighlight from "@/js/menu_highlight";
import header from "@/js/parts/header";
import initRecaptcha from "@/js/recaptcha"

window.addEventListener("DOMContentLoaded", async () => {
    pages();
    components();
    menuHighlight();
    forms();
    header();
    initRecaptcha()
});
